import apiClient from ".";
import { ObjectId } from "../models";
import { ISubscription } from "../models/subscription";


export const createCheckoutSession = async (body: {orgId: ObjectId, priceId: string}) => {
	const response = await apiClient.post<{sessionId: string}>( `/orgs/${body.orgId}/subscriptions/checkout-session`, body);
	return response.data;
}
export const createCustomerPortalSession = async (body: {orgId: ObjectId, subscriptionId: string}) => {
	const response = await apiClient.post<{url: string}>( `/orgs/${body.orgId}/subscriptions/customer-portal`, body);
	return response.data;
}
export const confirmSubscription = async (body: {orgId: ObjectId, sessionId: string}) => {
	const response = await apiClient.post(  `/orgs/${body.orgId}/subscriptions/confirm-subscription`, body);
	return response.data;
}

/**
 * Fetches the subscription details for a given organization.
 * @param orgId - The ID of the organization.
 * @returns The subscription details.
 */
export const getSubscription = async (orgId: ObjectId) => {
	const response = await apiClient.get<ISubscription>(`/orgs/${orgId}/subscription`);
	return response.data;
}
export const startFreeSubscription = async (body:{orgId: ObjectId, priceId: string}) => {
	const response = await apiClient.post<{subscriptionId: string}>( `/orgs/${body.orgId}/subscriptions/start-free-plan`, body);
	return response.data;
}

// Not finished
export type ProrateItem = {
	description: string | null;
    amount: number;
    currency: string;
    period: {
        start: string;
        end: string;
    };
}
export type PreviewResponse = {
	prorationItems: ProrateItem[],
	proration_date: number,
	priceId: string,
	newPriceId: string,
	subscriptionId: string,
	ordId: ObjectId,
	total: number,
	sessionId: string,
}
export const previewUpgrade = async (body: {orgId: ObjectId, subscriptionId: string, newPriceId: string}) => {
	const response = await apiClient.post<PreviewResponse>( `/orgs/${body.orgId}/subscriptions/upgrade-preview`, body);
	return response.data;
}
export const updateSubscription = async (body: {orgId: ObjectId, subscriptionId: string, newPriceId: string, proration_date: number}) => {
	const response = await apiClient.patch<{sessionId: string}>(`/orgs/${body.orgId}/subscriptions/update`, body);
	return response.data;
}
export const pauseSubscription = async (body: {orgId: ObjectId, subscriptionId: string}) => {
	const response = await apiClient.patch(`/orgs/${body.orgId}/subscriptions/pause`, body);
	return response.data;
}
export const cancelSubscription = async (body: {orgId: ObjectId, subscriptionId: string}) => {
	const response = await apiClient.patch(`/orgs/${body.orgId}/subscriptions/cancel`, body);
	return response.data;
}
export const resumeSubscription = async (body: {orgId: ObjectId, subscriptionId: string}) => {
	const response = await apiClient.patch<{sessionId: string}>(`/orgs/${body.orgId}/subscriptions/resume`, body);
	return response.data;
}